import { useSearchParams } from 'react-router-dom';
import { useTranslations } from 'use-intl';
import { LoginLayout } from '@/routes/trainee/login-layout';

export function LoginSent() {
  const [params] = useSearchParams();
  const t = useTranslations('login');
  const email = params.get('email') ?? '';
  return (
    <LoginLayout>
      <div className="p-8 text-center" data-testid="magic-link-sent">
        <p className="text-lg" data-testid="link-sent-message">
          {t('link_sent', { email })}
        </p>
        <br />
        <p data-testid="check-inbox-message">{t('check_inbox')}</p>
      </div>
    </LoginLayout>
  );
}
